import { render } from "./index.vue?vue&type=template&id=7fb250e2"
const script = {}

import "./index.vue?vue&type=style&index=0&id=7fb250e2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__